export default __webpack_public_path__ + "static/media/FinaceReport_Icon.a22690a2.png";